import {createContext, useContext} from "react";

/** Search / SearchDetailDrawer 내부 — 다중선택 비활성 */
export const SearchDetailContext = createContext(false);

export function useInSearchDetail() {
    return useContext(SearchDetailContext);
}
